<div class="add-food-bottomsheet-container" *ngIf="!cookingBook">
  <div class="add-food-bottomsheet-top" (swipedown)="swipe($event.type)">
    <div class="add-food-bottomsheet-top-indicator"></div>
  </div>
  <div class="add-food-bottomsheet-name" id="add-food-name">
    {{ data.food.name }}
  </div>
  <div
    *ngIf="unitTitle"
    class="add-food-bottomsheet-calorie"
    id="add-food-calorie"
  >
    {{ unitTitle }}
  </div>
  <div class="add-food-bottomsheet-input-holder">
    <input
      type="text"
      inputmode="decimal"
      [(ngModel)]="amount"
      (input)="calculateGram()"
      maxlength="5"
      placeholder="مقدار"
    />
    <!-- <img src="assets/plan/down-arrow-blue.svg"> -->
    <mat-select
      class="add-food-bottomsheet-select"
      [(ngModel)]="selectedRatio"
      (selectionChange)="calculateGram()"
      name="ratio"
    >
      <mat-option
        class="add-food-bottomsheet-option"
        *ngFor="let ratio of ratios"
        [value]="ratio"
      >
        {{ ratio }}
      </mat-option>
    </mat-select>
  </div>
  <div
    [ngClass]="
      isButtonActive
        ? 'add-food-bottomsheet-submit submit-active'
        : 'add-food-bottomsheet-submit submit-disable'
    "
    (click)="submit()"
    id="add-button"
  >
    ثبت
  </div>
</div>
<div class="add-food-bottomsheet-container" *ngIf="cookingBook && !selectUnit">
  <div class="cooking-header">
    <div class="title">
      <img src="assets/plans/edit-blue.svg" alt="" />

      <p>واحد</p>
    </div>
    <img
      src="assets/cookingbook/angle-down.svg"
      (click)="swipe(SWIPE_ACTION.DOWN)"
      alt=""
    />
  </div>

  <div class="add-food-bottomsheet-input-holder cooking-holder">
    <p class="cooking-unit-text">میزان واحد</p>
    <input
      type="text"
      inputmode="decimal"
      [(ngModel)]="amount"
      (input)="calculateGram()"
      maxlength="5"
      placeholder="مقدار"
    />
    <div (click)="openChangeUnit()">
      <p>
        {{ selectedRatio }}
      </p>
      <img src="assets/plans/edit-blue.svg" alt="" />
    </div>
  </div>
  <div
    [ngClass]="
      isButtonActive
        ? 'add-food-bottomsheet-submit submit-active cooking-button blue'
        : 'add-food-bottomsheet-submit submit-disable cooking-button'
    "
    (click)="submit()"
    id="add-button"
  >
    ثبت کنید
  </div>
</div>
<div class="add-food-bottomsheet-container" *ngIf="cookingBook && selectUnit">
  <div class="cooking-header">
    <div class="title">
      <img src="assets/cookingbook/more_blue.svg" alt="" />

      <p>یکی از گزینه های زیر را انتخاب کنید</p>
    </div>
    <img
      src="assets/cookingbook/angle-down.svg"
      (click)="backtoUnit()"
      alt=""
    />
  </div>

  <div class="cooking-ratio-holder">
    <div *ngFor="let ratio of ratios" class="cooking-ratio">
      <div (click)="changeCookingUnit(ratio)">
        <img
          src="assets/cookingbook/circle.svg"
          *ngIf="ratio != selectedRatio"
          alt=""
        />
        <img
          src="assets/cookingbook/circle_true.svg"
          *ngIf="ratio == selectedRatio"
          alt=""
        />

        <p>
          {{ ratio }}
        </p>
      </div>
    </div>
  </div>
</div>
